import classNames from "classnames";
import React from "react";

export type CardBodyComponentProps = {};

export type CardBodyProps<T extends React.ElementType> =
    PolymorphicComponentPropWithRef<T, CardBodyComponentProps, "div">;

const CardBody = React.forwardRef(
    <T extends React.ElementType = "div">(
        { className, tag, ...attributes }: CardBodyProps<T>,
        ref?: React.ForwardedRef<T>,
    ) => {
        const Tag = tag || ("div" as React.ElementType);
        const classes = classNames(className, "card-body");

        return <Tag {...attributes} className={classes} ref={ref} />;
    },
);

export { CardBody };
